<template>
  <v-dialog v-model="showModal" max-width="700px" persistent>
    <v-card flat>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>Dodawanie nowej procedury medycznej do wizyty</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-autocomplete :items="full_search_items" :loading="full_search_loading" return-object
                              label="Wyszukaj wszystko lub wybierz ręcznie poniżej..." v-model="full_search_selected"
                              hide-details no-data-text="Nie znaleziono" item-text="kod_opis" prepend-icon="fa-search"
                              :search-input.sync="icdKeyword" clearable></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :readonly="full_search_selected != null" :items="rozdzialy_z_domyslnymi"
                              :loading="loading_rozdzialy" return-object label="Rozdział"
                              v-model="wybrany_rozdzial"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :readonly="full_search_selected != null" :items="podrozdzialy"
                              :loading="loading_podrozdzialy" return-object label="Podrozdział"
                              v-model="wybrany_podrozdzial" v-if="podrozdzialy.length > 0"></v-autocomplete>
            </v-col>
            <v-col>
              <v-autocomplete :readonly="full_search_selected != null" :items="kategorie_glowne"
                              :loading="loading_kategorie_glowne" return-object label="Kategoria główna"
                              v-model="wybrana_kategoria_glowna" v-if="kategorie_glowne.length > 0"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :readonly="full_search_selected != null" :items="kategorie_szczegolowe"
                              :loading="loading_kategorie_szczegolowe" return-object label="Kategoria szczegółowa"
                              v-model="wybrana_kategoria_szczegolowa"
                              v-if="kategorie_szczegolowe.length > 0"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-checkbox label="Pokaż wszystkie rozdziały" v-model="pokaz_wszystkie_rozdzialy"></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="selectCategory()">Wybierz</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {icdService} from "@/services";
import swal from "sweetalert";

export default {
  name: "ICD9PIcker",
  props: ["visible", "visitid", "domyslne"],
  data() {
    return {
      rozdzialy: [],
      podrozdzialy: [],
      kategorie_glowne: [],
      kategorie_szczegolowe: [],
      wybrany_rozdzial: null,
      wybrany_podrozdzial: null,
      wybrana_kategoria_glowna: null,
      wybrana_kategoria_szczegolowa: null,
      pokaz_wszystkie_rozdzialy: false,
      loading_rozdzialy: false,
      loading_podrozdzialy: false,
      loading_kategorie_glowne: false,
      loading_kategorie_szczegolowe: false,
      full_search_items: [],
      full_search_loading: false,
      full_search_selected: null,
      icdKeyword: null
    }
  },
  mounted() {
    this.getMainCategories()
  },
  methods: {
    selectCategory() {
      if (this.full_search_selected != null) {
        this.$emit('category_selected', this.full_search_selected)
        return
      }
      if (this.wybrany_rozdzial == null) {
        this.showError('Nie wybrano rozdzialu.');
        return;
      }
      if (this.wybrany_podrozdzial == null && this.podrozdzialy.length > 0) {
        this.showError('Nie wybrano podrozdzialu.');
        return;
      }
      if (this.kategorie_glowne.length > 0 && this.wybrana_kategoria_glowna == null) {
        this.showError('Nie wybrano kategorii głównej.');
        return;
      }
      if (this.kategorie_szczegolowe.length > 0 && this.wybrana_kategoria_szczegolowa == null) {
        this.showError('Nie wybrano kategorii szczegółowej.');
        return;
      }
      let selectedValue = null;
      if (this.wybrany_rozdzial != null) {
        selectedValue = this.wybrany_rozdzial
      }
      if (this.wybrany_podrozdzial != null) {
        selectedValue = this.wybrany_podrozdzial
      }
      if (this.wybrana_kategoria_glowna != null) {
        selectedValue = this.wybrana_kategoria_glowna
      }
      if (this.wybrana_kategoria_szczegolowa != null) {
        selectedValue = this.wybrana_kategoria_szczegolowa
      }
      this.$emit('category_selected', selectedValue.value)
    },
    getDetailedCategories() {
      this.loading_kategorie_szczegolowe = true
      icdService.GetDetailedCategories(this.wybrana_kategoria_glowna.value.kod).then((result) => {
        this.loading_kategorie_szczegolowe = false
        if (result.data && result.data.result) {
          this.kategorie_szczegolowe = []
          result.data.result.forEach(x => {
            this.kategorie_szczegolowe.push({
              text: x.kod + ' ' + x.opis,
              value: x
            })
          })
        }
      }).catch(() => {
        this.loading_kategorie_szczegolowe = false
        this.showError('Błąd pobierania kategorii ICD9', true)
      })
    },
    getSubCategories() {
      this.loading_kategorie_glowne = true
      icdService.GetSubCategories(this.wybrany_podrozdzial.value.kod).then((result) => {
        this.loading_kategorie_glowne = false
        if (result.data && result.data.result) {
          this.kategorie_glowne = []
          result.data.result.forEach(x => {
            this.kategorie_glowne.push({
              text: x.kod + ' ' + x.opis,
              value: x
            })
          })
        }
      }).catch(() => {
        this.loading_kategorie_glowne = false
        this.showError('Błąd pobierania kategorii ICD9', true)
      })
    },
    getSubSections() {
      this.loading_podrozdzialy = true
      icdService.getSubSections(this.wybrany_rozdzial.value.kod).then((result) => {
        this.loading_podrozdzialy = false
        if (result.data && result.data.result) {
          this.podrozdzialy = []
          result.data.result.forEach(x => {
            this.podrozdzialy.push({
              text: x.kod + ' ' + x.opis,
              value: x
            })
          })
        }
      }).catch(() => {
        this.loading_podrozdzialy = false
        this.showError('Błąd pobierania kategorii ICD9', true)
      })
    },
    getMainCategories() {
      this.loading_rozdzialy = true
      icdService.getAllICD9MainCategories().then((result) => {
        this.loading_rozdzialy = false
        if (result.data && result.data.result) {
          this.rozdzialy = []
          result.data.result.forEach(x => {
            this.rozdzialy.push({
              text: x.kod + ' ' + x.opis,
              value: x
            })
          })
        }
      }).catch(() => {
        this.loading_rozdzialy = false
        this.showError('Błąd pobierania kategorii ICD9', true)
      })
    },
    getFullSearch() {
      this.full_search_loading = true
      icdService.GetFullSearchICD9(this.icdKeyword).then((result)=> {
        this.full_search_items = result.data.result
        this.full_search_loading = false
      }).catch(() => {
        this.showError('Błąd pobierania kategorii ICD9', true)
        this.full_search_loading = false
      })
    },
    showError(text, close) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
            if (close) {
              this.showModal = false
            }
          }
      )

    },
    resetValues() {
      this.podrozdzialy = []
      this.kategorie_glowne = []
      this.kategorie_szczegolowe = []
      this.wybrany_podrozdzial = null
      this.wybrana_kategoria_glowna = null
      this.wybrana_kategoria_szczegolowa = null
    }
  },
  watch: {
    full_search_selected: function(val) {
      if(val)
      {
        if(val.rozdzial_kod != null && val.rozdzial_kod.length > 0)
        {
          let newRozdzial = {
            text: val.rozdzial_kod + ' '+val.rozdzial,
            value: val.rozdzial_kod
          };
          this.rozdzialy = []
          this.rozdzialy.push(newRozdzial)
          this.wybrany_rozdzial = this.rozdzialy[0]
        }
        if(val.podrozdzial_kod != null && val.podrozdzial_kod.length > 0)
        {
          let newPodrozdzial = {
            text: val.podrozdzial_kod + ' '+val.podrozdzial,
            value: val.podrozdzial_kod
          }
          this.podrozdzialy = []
          this.podrozdzialy.push(newPodrozdzial)
          this.wybrany_podrozdzial = this.podrozdzialy[0]
        }
        if(val.kategoria_glowna_kod != null && val.kategoria_glowna_kod.length > 0)
        {
          let newKategoriaGlowna = {
            text: val.kategoria_glowna_kod + ' '+val.kategoria_glowna,
            value: val.kategoria_glowna_kod
          }
          this.kategorie_glowne = []
          this.kategorie_glowne.push(newKategoriaGlowna)
          this.wybrana_kategoria_glowna = this.kategorie_glowne[0]
        }
        if(val.kategoria_szczegolowa_kod != null && val.kategoria_szczegolowa_kod.length > 0)
        {
          let newKategoriaSzczegolowa = {
            text: val.kategoria_szczegolowa_kod + ' '+val.kategoria_szczegolowa,
            value: val.kategoria_szczegolowa_kod
          }
          this.kategorie_szczegolowe = []
          this.kategorie_szczegolowe.push(newKategoriaSzczegolowa)
          this.wybrana_kategoria_szczegolowa = this.kategorie_szczegolowe[0]
        }
      }
      else
      {
        this.resetValues()
        this.getMainCategories()
      }
    },
    icdKeyword: function(val) {
      if(val)
        this.getFullSearch()
    },
    wybrany_rozdzial: function (val) {
      if(this.full_search_selected) return
      if (val) {
        this.getSubSections()
      } else {
        this.resetValues()
      }
    },
    wybrany_podrozdzial: function (val) {
      if(this.full_search_selected) return
      if (val) {
        this.getSubCategories()
      }
    },
    wybrana_kategoria_glowna: function (val) {
      if(this.full_search_selected) return
      if (val) {
        this.getDetailedCategories()
      }
    },
    pokaz_wszystkie_rozdzialy: function (val) {
      this.resetValues()
    }
  },
  computed: {
    showModal: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        if (!value) {
          this.$emit('close')
        }

      }
    },
    rozdzialy_z_domyslnymi: {
      get: function () {
        if (this.pokaz_wszystkie_rozdzialy || this.full_search_selected)
          return this.rozdzialy
        else if (this.domyslne && this.domyslne.length > 0) {
          return this.rozdzialy.filter(rozdzial => this.domyslne.find(x => x.category == rozdzial.value.kod))
        }
        return this.rozdzialy
      }
    }
  }
}
</script>

<style scoped>

</style>